/* eslint-disable */
export default {
  meetingTitle: '{extensionName}’s Meeting',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
